import { render, staticRenderFns } from "./SkuMateriales.vue?vue&type=template&id=5925f5b2&scoped=true&"
import script from "./SkuMateriales.vue?vue&type=script&lang=js&"
export * from "./SkuMateriales.vue?vue&type=script&lang=js&"
import style0 from "./SkuMateriales.vue?vue&type=style&index=0&id=5925f5b2&prod&lang=scss&scoped=true&"
import style1 from "./SkuMateriales.vue?vue&type=style&index=1&id=5925f5b2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5925f5b2",
  null
  
)

export default component.exports